import { AsyncActions } from '@telstra-connect/standard-actions';

export interface IRequestStatus {
    status: AsyncActions.AsyncActionState;
    error?: string;
    errorCode?: string;
}

export function requestStarted(request: IRequestStatus): boolean {
    return request.status === AsyncActions.AsyncActionState.Initiated;
}

export function requestNotStarted(request: IRequestStatus): boolean {
    return request.status === AsyncActions.AsyncActionState.NotStarted;
}

export function anyRequestStarted(...requests: IRequestStatus[]): boolean {
    return requests.length > 0 &&
        requests.some((r) => r.status === AsyncActions.AsyncActionState.Initiated);
}

export function requestFailed(request: IRequestStatus) {
    return (request.status === AsyncActions.AsyncActionState.Failure);
}

export function requestSucceeded(request: IRequestStatus): boolean {
    return request.status === AsyncActions.AsyncActionState.Success;
}

export function anyRequestFailed(...requests: IRequestStatus[]): boolean {
    return requests.length > 0 &&
        requests.some((r) => r.status === AsyncActions.AsyncActionState.Failure);
}

export function requestFinished(request: IRequestStatus): boolean {
    return request.status === AsyncActions.AsyncActionState.Failure ||
        request.status === AsyncActions.AsyncActionState.Success;
}

export function allRequestsFinished(...requests: IRequestStatus[]): boolean {
    return requests.length > 0 &&
        requests.every((r) => r.status === AsyncActions.AsyncActionState.Failure ||
            r.status === AsyncActions.AsyncActionState.Success);
}

export function isRequestStatusSame(left: IRequestStatus[], right: IRequestStatus[]): boolean {
    if (left.length !== right.length) {
        return false;
    }
    const leftSet = new Set(left.map((item) => item.status));
    const rightSet = new Set(right.map((item) => item.status));
    return leftSet.size === rightSet.size &&
        Array.from(leftSet.keys()).every((status) => rightSet.has(status));
}

export function requestFailedForCard(request: IRequestStatus) {
    return (request.status === AsyncActions.AsyncActionState.Failure);
}
